module.exports = __webpack_public_path__ + "img/mv.e96351f.svg";